if (!customElements.get('custom-quantity-selector')) {
  class CustomQuantitySelector extends HTMLElement {
    constructor() {
      super();
      this.selectedBundle = null;
      this.init();
    }

    init() {
      this.setupEventListeners();
      this.setupVariantChangeListener();
      this.setupMainFormListener();
    }

    get productId() {
      return this.dataset.productId;
    }

    get sectionId() {
      return this.dataset.sectionId;
    }

    get mainProductForm() {
      // Use the section ID to find the correct form
      const formId = `product-form-${this.sectionId}`;
      console.log('Looking for form with ID:', formId);
      const form = document.getElementById(formId);
      console.log('Form found:', form);
      
      // Fallback: try to find any product form
      if (!form) {
        console.log('Trying fallback selector: form[data-type="add-to-cart-form"]');
        return document.querySelector('form[data-type="add-to-cart-form"]');
      }
      
      return form;
    }

    get quantityInput() {
      const form = this.mainProductForm;
      if (!form) {
        console.log('No form found, cannot get quantity input');
        return null;
      }
      
      // First try to find input inside the form
      let input = form.querySelector('input[name="quantity"]');
      
      // If not found, the input might be outside with form attribute pointing to this form
      if (!input) {
        const formId = form.getAttribute('id');
        console.log('Input not in form, looking for input with form attribute:', formId);
        input = document.querySelector(`input[name="quantity"][form="${formId}"]`);
        
        if (!input) {
          // Debug: Let's see what quantity inputs exist
          console.log('Still not found. All quantity inputs on page:');
          const allQuantityInputs = document.querySelectorAll('input[name="quantity"]');
          allQuantityInputs.forEach(inp => {
            console.log('- Input:', inp, 'form attr:', inp.getAttribute('form'));
          });
          
          // Try using ID instead
          const quantityId = `Quantity-${this.sectionId}`;
          console.log('Trying with ID:', quantityId);
          input = document.getElementById(quantityId);
        }
      }
      
      console.log('Quantity input found:', input);
      return input;
    }

    setupEventListeners() {
      const items = this.querySelectorAll('.custom-quantity__item');
      
      items.forEach(item => {
        item.addEventListener('click', this.handleBundleSelection.bind(this));
      });
    }

    setupMainFormListener() {
      // Listen for main form submission to inject bundle quantity
      if (this.mainProductForm) {
        // Intercept form submission to inject quantity
        this.mainProductForm.addEventListener('submit', (e) => {
          if (this.selectedBundle) {
            console.log('Form submitting with bundle quantity:', this.selectedBundle.quantity);
            
            // Check if quantity input exists
            let quantityInput = this.quantityInput;
            
            if (quantityInput) {
              // Update existing input
              quantityInput.value = this.selectedBundle.quantity;
              console.log('Updated existing quantity input to:', this.selectedBundle.quantity);
            } else {
              // No quantity input exists - create a hidden one
              console.log('No quantity input found, creating hidden input');
              const hiddenInput = document.createElement('input');
              hiddenInput.type = 'hidden';
              hiddenInput.name = 'quantity';
              hiddenInput.value = this.selectedBundle.quantity;
              hiddenInput.setAttribute('data-bundle-quantity', 'true');
              this.mainProductForm.appendChild(hiddenInput);
              console.log('Created hidden quantity input with value:', this.selectedBundle.quantity);
            }
          }
          
          // After successful add to cart, deselect the bundle
          document.addEventListener('product-ajax:added', () => {
            this.deselectAllBundles();
            // Clean up any hidden inputs we created
            const hiddenQty = this.mainProductForm.querySelector('input[data-bundle-quantity="true"]');
            if (hiddenQty) {
              hiddenQty.remove();
            }
          }, { once: true });
        }, true); // Use capture phase
      } else {
        console.error('Main product form not found during setup!');
      }
    }

    handleBundleSelection(event) {
      event.preventDefault();
      const item = event.currentTarget;
      
      // Check if item is disabled
      if (item.hasAttribute('data-disabled')) return;

      const quantity = parseInt(item.dataset.quantity);
      
      // Check if clicking the same bundle (deselect)
      if (item.classList.contains('is-selected')) {
        this.deselectBundle(item);
      } else {
        this.selectBundle(item, quantity);
      }
    }

    selectBundle(item, quantity) {
      // Deselect any previously selected bundle
      this.deselectAllBundles();
      
      // Select the new bundle
      item.classList.add('is-selected');
      this.selectedBundle = {
        element: item,
        quantity: quantity
      };
      
      console.log('Bundle selected with quantity:', quantity);
      console.log('Section ID:', this.sectionId);
      console.log('Product ID:', this.productId);
      console.log('Quantity input found:', this.quantityInput);
      console.log('Quantity input value before update:', this.quantityInput?.value);
      
      // Update the main form quantity
      this.updateMainFormQuantity(quantity);
      
      console.log('Quantity input value after update:', this.quantityInput?.value);
      
      // Dispatch custom event
      this.dispatchEvent(new CustomEvent('bundle:selected', {
        bubbles: true,
        detail: { quantity, item }
      }));
    }

    deselectBundle(item) {
      item.classList.remove('is-selected');
      this.selectedBundle = null;
      
      // Reset main form to default quantity (1)
      this.updateMainFormQuantity(1);
      
      // Dispatch custom event
      this.dispatchEvent(new CustomEvent('bundle:deselected', {
        bubbles: true,
        detail: { item }
      }));
    }

    deselectAllBundles() {
      const allItems = this.querySelectorAll('.custom-quantity__item');
      allItems.forEach(item => {
        item.classList.remove('is-selected');
      });
      this.selectedBundle = null;
      this.updateMainFormQuantity(1);
    }

    updateMainFormQuantity(quantity) {
      const quantityInput = this.quantityInput;
      if (quantityInput) {
        console.log('Updating quantity input to:', quantity);
        quantityInput.value = quantity;
        
        // Trigger change event for any quantity watchers
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        console.log('No quantity input to update - will inject on form submit');
      }
    }

    updateBundlePrices(sellingPlanId) {
      const priceElems = this.querySelectorAll('.js-price');
      priceElems.forEach(priceEl => {
        const sellingPlanCalculatePrice = priceEl.closest('.js-item').dataset[`sellingPlan-${sellingPlanId}Price`];
        priceEl.textContent = sellingPlanCalculatePrice;
      });
    }

    updateDiscountBadges(sellingPlanId) {
      const discountElems = this.querySelectorAll('.js-discount');
      discountElems.forEach(discountEl => {
        const sellingPlanCalculateDiscount = Number(discountEl.closest('.js-item').dataset[`sellingPlan-${sellingPlanId}Discount`]);

        discountEl.closest('.js-badge').style.display = sellingPlanCalculateDiscount === 0 ? 'none' : 'block';
        discountEl.textContent = sellingPlanCalculateDiscount;
      });
    }

    setupVariantChangeListener() {
      if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
        this.onVariantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleVariantChange.bind(this)
        );
        
        // Listen to quantity updates that might reset our bundle quantity
        this.onQuantityUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate,
          this.handleQuantityUpdate.bind(this)
        );
      }
    }

    handleVariantChange({ data: { selectedOptionValues } }) {
      const productInfo = document.querySelector(`product-info[data-product-id="${this.productId}"]`);
      
      if (!productInfo) {
        const productForm = document.querySelector(`form[data-product-id="${this.productId}"]`);

        if (productForm) {
          const variantInput = productForm.querySelector('input[name="id"]');

          if (variantInput) {
            this.updateButtonsForVariant(variantInput.value);
          }
        }
        return;
      }

      const variantInput = productInfo.querySelector('input[name="id"]');
      if (!variantInput) return;

      const currentVariantId = variantInput.value;
      this.updateButtonsForVariant(currentVariantId);
    }

    handleQuantityUpdate() {
      // When quantity boundaries are updated (which resets the quantity to min),
      // restore the bundle quantity if a bundle is selected
      if (this.selectedBundle && this.quantityInput) {
        console.log('Quantity update detected - restoring bundle quantity:', this.selectedBundle.quantity);
        this.updateMainFormQuantity(this.selectedBundle.quantity);
      }
    }

    updateButtonsForVariant(variantId) {
      if (!variantId) return;

      this.querySelectorAll('.custom-quantity__item').forEach(item => {
        item.dataset.variantId = variantId;
        item.removeAttribute('data-disabled');
      });

      this.dataset.variantId = variantId;
      
      // If a bundle is selected, maintain the quantity
      if (this.selectedBundle) {
        this.updateMainFormQuantity(this.selectedBundle.quantity);
      }
    }

    disconnectedCallback() {
      if (this.onVariantChangeUnsubscriber) {
        this.onVariantChangeUnsubscriber();
      }
      if (this.onQuantityUpdateUnsubscriber) {
        this.onQuantityUpdateUnsubscriber();
      }
    }
  }

  customElements.define('custom-quantity-selector', CustomQuantitySelector);
}